/* eslint-disable react/no-danger */
import React from 'react'

export default ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
)
